import styled from "styled-components";

export const BreadcrumbContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-content: stretch;
  align-items: center;
  background: ${(props) => props.theme.colors.primaryWhite};
  padding: 8px 24px;
  border: 1px solid ${(props) => props.theme.colors.borderGray};
  overflow: hidden;
  max-height: 1.75rem;
  font-size: 0.625em;
  font-weight: bold;

  a {
    font-size: 0.625em;
    font-weight: bold;
  }
`;
